import React from 'react';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';

import Dialog from 'xgimi-ui/Dialog';
import Form from 'xgimi-ui/Form';
import InfoText from 'xgimi-ui/Info/Text';
import Button from 'xgimi-ui/Button';

import StoreComponent, { mapStateToProps } from '../../../../../appComponents/Store';

import s from './.module.scss';
import Api from '../../../../../api';

interface Props {
  // 是否打开
  isOpen: boolean;
  // 数据
  data: Record<string, any>;
  // 关闭
  onClose: () => void;
  // 保存成功
  onSuccess: () => void;

}

interface State {
}

/**
 * 备注
 */
class Component extends StoreComponent<Props, State> {
  // 备注内容
  private content: string = '';

  /**
   * 确认
   */
  private onConfirm = (): void => {
    if (this.content === '') {
      this.storeState.common.toast.current?.show({ content: '请输入备注信息' });
      return;
    }
    this.remark();
  };

  /**
   * 备注
   */
  private remark = (): void => {
    new HttpStateLine(new Api.crmFeedback.SaveDeal({
      feedbackNo: this.props.data.feedbackNo,
      remark: this.content,
    }), {
      onSuccess: () => {
        this.props.onSuccess();
         this.storeState.common.toast.current?.show({ content: '添加成功' });
      },
      onFail: (httpStateLine) => {
        this.storeState.common.toast.current?.show({ content: httpStateLine.result?.message });
      },
    }).run();
  };

  render(): React.ReactNode {
    return (
      <Dialog
        className={s.dialog}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
        isResponsive={true}
        isAutoClose={true}
      >
        <div className={s.container}>
          <div className={s.actionButton}>
            <Button size="large" variant="text" color="primary" onClick={this.props.onClose}>取消</Button>
            <Button size="large" variant="text" color="primary" onClick={this.onConfirm}>确定</Button>
          </div>
          <Form className={s.form}>
            <InfoText
              className={s.remark}
              rowSize={8}
              placeholder="请输入备注信息"
              isUpdate={true}
              variant="outlined"
              onUpdate={(data) => {
                this.content = data;
              }}
            />
          </Form>
        </div>
      </Dialog>
    );
  }
}
export default connect(mapStateToProps)(Component);
